import type { BotStrategySettingResponse } from 'api/elplan/elplan.types'
import type { RowValues } from 'ui/components/HourlyDataTable/HourlyDataTable.types'
import { serializeDecimalInputText } from 'utils/numberUtils/decimalInput'
import { extractHourIndex } from '../../../helpers/intradayBidSubmissions.helper'
import { makeStrategyCellKey } from '../tableCellAdapters/strategyTableAdapter'

export function mapBotStrategyResponseToRowValues(
  response: BotStrategySettingResponse,
  bidBaseStartTime: Date,
  maxHours: number
): RowValues[] {
  const rows: RowValues[] = Array.from({ length: maxHours }, () => ({}))
  for (const s of response.series) {
    for (const entry of s.values) {
      const hourIndex = extractHourIndex(entry.time, bidBaseStartTime)
      if (Number.isNaN(hourIndex) || hourIndex < 0 || hourIndex >= maxHours) continue
      if (entry.value === 0) continue
      const cellKey = makeStrategyCellKey(hourIndex, s.series_id)
      rows[hourIndex] = { ...rows[hourIndex], [cellKey]: serializeDecimalInputText(entry.value) }
    }
  }
  return rows
}
